import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import ModalCreateFoodType from "./modalCreateFoodType";
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import ModalEditFoodType from "./modalEditFoodType";
import {createSearchParams} from "react-router-dom";
import LinkPlus from "../../../../components/Link/LinkPlus";
import FoodController from "../../../../services/system/food/food-controller";
import {getSchoolYear} from "../../../../utils/authority";
import Utils from "../../../../utils/utils";
registerLocale("vi", vi);
class FoodManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            foodCategoryId: -1,
            name: "",
            usual: "",
            pageNumber: 0,
            pageSize: 20,
            totalItem: 0,
            listFoodCategory: [],
            listData: [],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên thực phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã thực phẩm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Loại thực phẩm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "group",
                    name: "Nhóm thực phẩm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "supplier",
                    name: "Nhà cung cấp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "percent",
                    name: "Hệ số thải bỏ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "dam",
                    name: "Đạm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "beo",
                    name: "Béo",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "duong",
                    name: "Đường",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "calo",
                    name: "Calo",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "canxi",
                    name: "Canxi",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Đơn giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "dv",
                    name: "Đơn vị tính",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "use",
                    name: "Thường dùng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListFoodCategory()
        this.getListFood()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListFood();
            }
        );
    };
    getListFood() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            foodCategoryId: this.state.foodCategoryId,
            name: this.state.name,
            usual: this.state.usual,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        FoodController.searchFood(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListFood()
    }
    onHandleRefresh(){
        this.setState({
            foodCategoryId: -1,
            name: "",
            usual: "",
            pageNumber: 0
        }, () =>{
            this.getListFood()
        });
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListFoodCategory() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            sort: "created_at desc",
            name: "",
        };
        FoodController.searchCategory(payload, res => {
            this.setState({
                showLoading: false,
                listFoodCategory: res.data.content,
            });
        })
    }
    renderFoodCategory() {
        return this.state.listFoodCategory.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="food" parentClass="menu-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý thực phẩm"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại thực phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.foodCategoryId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            foodCategoryId: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn loại thực phẩm</option>
                                                    {this.renderFoodCategory()}
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Tên thực phẩm</label>
                                                <input
                                                    placeholder="Nhập tên thực phẩm"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.name}
                                                    maxLength={256}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({name: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Thường dùng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.usual}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            usual: e.target.value
                                                        }, () =>{
                                                            this.getListFood()
                                                        })
                                                    }}
                                                >
                                                    <option value="all">Tất cả</option>
                                                    <option value="true">Có</option>
                                                    <option value="false">Không</option>

                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>

                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm ml-3"
                                                    onClick={() => this.onHandleRefresh()}
                                                >
                                                    Refresh
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/tao-thuc-pham",
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> Thực phẩm đã được áp dụng thì không xóa được</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListFood()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.code}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.categoryRes?.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.groupRes?.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.providerRes?.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.rationDispose} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.protit} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.lipit} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.gluxit} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.calcium} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.calo} %
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.unitPrice)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.unitCalculate}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.usual?"Có":"Không"}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/sua-thuc-pham",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalEditFoodType
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalCreateFoodType
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default FoodManagement;
